import type { ReactNode } from 'react';
import { Box, Typography } from '@mui/material';

import { footer } from '../copy';

export interface PayerConnectionsFooterProps {
  liveCount: number;
  unknownCount?: number;
  /** Right-aligned slot (e.g. "Add a payer") — left to the wiring slice. */
  rightSlot?: ReactNode;
}

/** AC-4: the payer table's footer — live count, or "No payers live yet". */
export function PayerConnectionsFooter({
  liveCount,
  rightSlot,
  unknownCount = 0,
}: PayerConnectionsFooterProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        px: '20px',
        py: '13px',
        backgroundColor: '#fafafd',
        borderTop: '1px solid #eeeef4',
      }}
    >
      <Typography sx={{ fontSize: '12.5px', color: '#6b6b78' }}>
        {footer(liveCount, unknownCount)}
      </Typography>
      {rightSlot}
    </Box>
  );
}
